import React, { useState, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import axios from "axios";
import dayjs from "dayjs";
import { API_BASE_URL } from "../config";

const CadastroResumo = ({ chamadaId, turmaId, setShowResumoForm, atualizarResumos, dataChamada }) => {
  const [resumos, setResumos] = useState([]);
  const isMobile = window.innerWidth <= 768;
  const [resumoData, setResumoData] = useState({
    id: null,
    resumo: "",
    link: "",
    linkYoutube: "",
    arquivo: null,
    aula: "",
  });

  const isValidYmd = (year, month, day) => {
    const y = Number(year);
    const m = Number(month);
    const d = Number(day);

    if (!Number.isInteger(y) || !Number.isInteger(m) || !Number.isInteger(d)) return false;
    if (m < 1 || m > 12 || d < 1 || d > 31) return false;

    const dt = new Date(Date.UTC(y, m - 1, d));
    return dt.getUTCFullYear() === y && dt.getUTCMonth() + 1 === m && dt.getUTCDate() === d;
  };

  const normalizeResumoDate = (value) => {
    if (!value) return null;

    if (typeof value === "string") {
      const trimmedValue = value.trim();

      if (/^\d+$/.test(trimmedValue)) {
        return null;
      }

      // Backend format (YYYY-MM-DD ou YYYY/MM/DD)
      const ymdMatch = trimmedValue.match(/^(\d{4})[-/](\d{2})[-/](\d{2})$/);
      if (ymdMatch) {
        const [, year, month, day] = ymdMatch;
        return isValidYmd(year, month, day) ? `${year}-${month}-${day}` : null;
      }

      // Front format (DD-MM-YYYY ou DD/MM/YYYY)
      const dmyMatch = trimmedValue.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
      if (dmyMatch) {
        const [, day, month, year] = dmyMatch;
        return isValidYmd(year, month, day) ? `${year}-${month}-${day}` : null;
      }

      const parsedDate = dayjs(trimmedValue);
      if (!parsedDate.isValid()) return null;

      const normalized = parsedDate.format("YYYY-MM-DD");
      const [year, month, day] = normalized.split("-");
      return isValidYmd(year, month, day) ? normalized : null;
    }

    if (typeof value === "number") {
      return null;
    }

    const parsedDate = dayjs(value);
    return parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : null;
  };

  // Buscar resumos associados a uma chamada
  const fetchResumos = async () => {
    if (!dataChamada) return;

    const formattedDate = normalizeResumoDate(dataChamada);
    if (!formattedDate) {
      console.warn("Data inválida para buscar resumos:", dataChamada, "chamadaId:", chamadaId);
      return;
    }

    try {
      const response = await axios.get(`${API_BASE_URL}/resumos/${formattedDate}/${turmaId}`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
      });
      setResumos(response.data);

      if (response.data && response.data.length > 0) {
        const item = response.data[0];
        setResumoData({
          id: item.cp_res_id,
          resumo: item.cp_res_resumo || "",
          link: item.cp_res_link || "",
          linkYoutube: item.cp_res_link_youtube || "",
          aula: item.cp_res_aula || "",
          arquivo: null,
        });
      } else {
        setResumoData({
          id: null,
          resumo: "",
          link: "",
          linkYoutube: "",
          aula: "",
          arquivo: null,
        });
      }
    } catch (error) {
      console.error("Erro ao buscar resumos:", error);
      toast.error("Erro ao buscar resumos. Tente novamente mais tarde.");
    }
  };

  // Salva novo resumo ou atualiza o resumo que foi aberto.
  const handleSaveResumo = async () => {
    const formData = new FormData();

    // Capturar a data e hora no formato correto
    // const currentDate = new Date();
    // const formattedDate = currentDate.toISOString().split('T')[0]; // Exemplo: "2024-12-19"
    // const formattedTime = currentDate.toTimeString().split(' ')[0]; // Exemplo: "12:40:00"

    formData.append("turmaId", turmaId);
    formData.append("resumo", resumoData.resumo);
    formData.append("link", resumoData.link);
    formData.append("linkYoutube", resumoData.linkYoutube);
    formData.append("aula", resumoData.aula);
    // formData.append("data", formattedDate);
    // formData.append("hora", formattedTime);
    const formattedDate = normalizeResumoDate(dataChamada);
    if (!formattedDate) {
      toast.error("Data da chamada inválida para salvar resumo.");
      return;
    }
    formData.append("data", formattedDate);

    if (resumoData.arquivo) {
      formData.append("arquivo", resumoData.arquivo);
    }

    try {
      const headers = {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('token')}`
      };

      if (resumoData.id) {
        await axios.put(`${API_BASE_URL}/resumos/${resumoData.id}`, formData, { headers });
      } else {
        await axios.post(`${API_BASE_URL}/resumos`, formData, { headers });
      }

      toast.success(resumoData.id ? "Resumo atualizado com sucesso." : "Resumo salvo com sucesso.");
      setResumoData({
        id: null,
        resumo: "",
        link: "",
        linkYoutube: "",
        arquivo: null,
        aula: ""
      });
      fetchResumos();
      console.log("Etapa 1: Chamando atualizarResumos no cadastro.");
      atualizarResumos(); // Envia o "sinal"
      setShowResumoForm(false); // Fecha o formulário
    } catch (error) {
      console.error("Erro ao salvar resumo:", error);
      toast.error("Erro ao salvar resumo. Tente novamente mais tarde.");
    }
  };



  useEffect(() => {
    if (dataChamada && turmaId) {
      fetchResumos();
    }
  }, [dataChamada, turmaId]);

  return (
    <div
      className={`${isMobile ? "col-4 p-3" : "col p-3"} resumo-panel`}
      style={
        isMobile
          ? {
            width: "calc(100% - 30px)",
            position: "fixed",
            top: "50%",
            // margin: "0 10px",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#868f93",
            zIndex: 1050,
            borderRadius: "8px",
            boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          }
          : {}
      }
    >
      <Form>
        <Form.Group>
          <Form.Label>Resumo</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            // onChange={(e) => setResumoData((prev) => ({ ...prev, resumo: e.target.value }))}
            value={resumoData.resumo}
            onChange={(e) => setResumoData({ ...resumoData, resumo: e.target.value })}
          />
        </Form.Group>
        <Form.Group className="mt-3">
          <Form.Label>Link</Form.Label>
          <Form.Control
            type="text"
            value={resumoData.link}
            onChange={(e) => setResumoData((prev) => ({ ...prev, link: e.target.value }))}
          />
        </Form.Group>
        <Form.Group className="mt-3">
          <Form.Label>Link do YouTube</Form.Label>
          <Form.Control
            type="text"
            value={resumoData.linkYoutube}
            onChange={(e) => setResumoData((prev) => ({ ...prev, linkYoutube: e.target.value }))}
          />
        </Form.Group>
        <Form.Group className="mt-3">
          <Form.Label>Arquivo</Form.Label>
          <Form.Control
            type="file"
            onChange={(e) => setResumoData((prev) => ({ ...prev, arquivo: e.target.files[0] }))}
          />
        </Form.Group>
        <Form.Group className="mt-3">
          <Form.Label>Aula</Form.Label>
          <Form.Control
            type="text"
            value={resumoData.aula}
            onChange={(e) => setResumoData((prev) => ({ ...prev, aula: e.target.value }))}
          />
        </Form.Group>
        <Button type="button" className="mt-3" onClick={handleSaveResumo}>
          Salvar Resumo
        </Button>
      </Form>
      <hr />
    </div>
  );
};

export default CadastroResumo;
